var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "home_pin"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2191_1074",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 34
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 34,
    height: 34,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2191_1074)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "home_pin_2",
    d: "M12.7513 18.4163H15.5846V14.5205H18.418V18.4163H21.2513V11.6872L17.0013 8.85384L12.7513 11.6872V18.4163ZM17.0013 27.4122C19.8819 24.7677 22.0187 22.3653 23.4117 20.2049C24.8048 18.0445 25.5013 16.1261 25.5013 14.4497C25.5013 11.8761 24.6808 9.76877 23.0398 8.1278C21.3989 6.48683 19.386 5.66634 17.0013 5.66634C14.6166 5.66634 12.6037 6.48683 10.9628 8.1278C9.32179 9.76877 8.5013 11.8761 8.5013 14.4497C8.5013 16.1261 9.19783 18.0445 10.5909 20.2049C11.9839 22.3653 14.1207 24.7677 17.0013 27.4122ZM17.0013 31.1663C13.1999 27.9316 10.3607 24.9271 8.48359 22.1528C6.60651 19.3785 5.66797 16.8108 5.66797 14.4497C5.66797 10.908 6.8072 8.08648 9.08568 5.98509C11.3641 3.8837 14.0027 2.83301 17.0013 2.83301C19.9999 2.83301 22.6385 3.8837 24.9169 5.98509C27.1954 8.08648 28.3346 10.908 28.3346 14.4497C28.3346 16.8108 27.3961 19.3785 25.519 22.1528C23.6419 24.9271 20.8027 27.9316 17.0013 31.1663Z",
    fill: "#FE6728"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.677c7bbe18cf9848e46ebd7ab3aba7be.svg";
export { ForwardRef as ReactComponent };